/**
 * Presentational list of sessions. Holds no state and does not re-sort:
 * the route passes an already-sorted array.
 */
import { Button, Card } from "@sportsmet/ui";
import type { ReactNode } from "react";

import {
  sessionSecondaryLine,
  type typeSessionRow,
} from "./sessionsScreenLogic";

export const SessionList = ({
  sessions,
  nowMs,
  signOutLabel,
  onSignOut,
  signingOutSessionId,
}: {
  /** Already sorted by `sortSessionsForDisplay`. This component does not re-sort. */
  sessions: readonly typeSessionRow[];
  nowMs: number;
  signOutLabel: string;
  onSignOut: (session: typeSessionRow) => void;
  /** The one row whose revoke is in flight, or null. Never a shared `isPending`. */
  signingOutSessionId: string | null;
}): ReactNode => (
  <Card padding="none">
    <ul className="flex flex-col">
      {sessions.map((session) => (
        <li
          key={session.sessionId}
          data-testid={`sessions-row-${session.sessionId}`}
          className="flex items-center justify-between gap-3 border-b border-hairline px-4 py-3 last:border-b-0"
        >
          <div className="flex min-w-0 flex-col gap-1">
            <p className="truncate text-body-strong text-ink">
              {session.deviceLabel}
            </p>
            <p className="text-caption text-ink-secondary">
              {sessionSecondaryLine(session, nowMs)}
            </p>
          </div>
          {session.isCurrent ? null : (
            <Button
              variant="ghost"
              size="sm"
              aria-label={`Sign out of ${session.deviceLabel}`}
              loading={signingOutSessionId === session.sessionId}
              loadingLabel={`Signing out of ${session.deviceLabel}`}
              onClick={() => {
                onSignOut(session);
              }}
            >
              {signOutLabel}
            </Button>
          )}
        </li>
      ))}
    </ul>
  </Card>
);
